module.exports = __webpack_public_path__ + "img/iDEAL_Wero_Lockup_Yellow_Square_RGB.f43da5b8.svg";